import React from 'react';

const PrimaryButton = ({
    children,
    className,
    type = 'button',
    disabled,
    ...props
}) => {
    return (
        <button
            className={`
                focus:border-black btn bg-indigo-500 hover:bg-indigo-600 text-white
                ${disabled ? '!bg-gray-400 !hover:bg-gray-400 !cursor-not-allowed' : ''}
                ${className}
            `}
            type={type}
            disabled={disabled}
            {...props}
        >
            {children}
        </button>
    );
};

export default PrimaryButton;
